module.exports = __webpack_public_path__ + "static/media/bg-15fps.b38e1980.mp4";